import React from "react";
import footerimg from "./assets/logo.webp";
import { IoMailOpenOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { LuPhoneCall } from "react-icons/lu";
function Footer() {
  return (
    <>
      <footer id="footer" className="footer position-relative">
        <div className="container">
          <div className="row gy-5">
            <div className="col-lg-4">
              <div className="footer-brand">
                <a href="" className="logo d-flex align-items-center mb-3">
                  <span className="sitename">
                    <img src={footerimg} className="img-fluid" />
                  </span>
                </a>
                <p className="tagline">
                  The Karbi Lammet Amei came into existence on 27th March, 1966
                  at the residence of Sar Dhaniram Rongpi, the then C.E.M of
                  Karbi Anglong Autonomous Council.
                </p>

                <div className="social-links mt-4">
                  <a href="/" className="facebook">
                    <LuPhoneCall />
                  </a>
                  <a
                    href="mailto:klacentralcommittee@gmail.com"
                    className="facebook me-2"
                  >
                    <IoMailOpenOutline
                      style={{ fontSize: "20px", margin: "auto 10px" }}
                    />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="footer-links-grid">
                <div className="row">
                  <div className="col-6 col-md-4">
                    <h5>Useful Links</h5>
                    <ul className="list-unstyled">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>
                        <Link to="/about-us">About</Link>
                      </li>
                      <li>
                        <Link to="/gallery">Gallery</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-6 col-md-4">
                    <h5>Links</h5>
                    <ul className="list-unstyled">
                      <li>
                        <Link to="/publications">Publications</Link>
                      </li>
                      <li>
                        <Link to="/committee">Committee</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-6 col-md-4">
                    <h5>Support</h5>
                    <ul className="list-unstyled">
                      <li>
                        <Link to="/">Help Center</Link>
                      </li>
                      <li>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                      <li>
                        <Link to="/">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/">Terms of Service</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-2">
              <div className="footer-cta">
                <h5>Let's Connect</h5>
                <Link to="/contact-us" className="btn btn-outline">
                  Get in Touch
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="footer-bottom-content">
                  <p className="mb-0">
                    © <span className="sitename">KarbiLammetAmeiCC</span>. All
                    rights reserved.
                  </p>
                  {/* <div className="credits">
                    Designed by <a href="https://bootstrapmade.com/">ANKUR</a>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
